import React from "react";
import { useHighlight } from "../useHighlight";

const HighlightOverlay = () => {
  const { Portal, targetStyle, turnOff, turnOn } = useHighlight();

  return (
    <>
      {Portal}
      <h1 className="mt-14 mb-2 text-3xl">Highlight overlay</h1>
      <div
        style={targetStyle}
        onMouseEnter={turnOn}
        onMouseLeave={turnOff}
        className="rounded-full shadow-md p-10 text-white outline-none focus:outline-none bg-purple-800 duration-500 transition-all "
      >
        When you hover over this element, it will be highlighted
      </div>
    </>
  );
};

export default HighlightOverlay;
